<section style="min-height:80vh;display:flex;align-items:center;justify-content:center;background:#f9fafb;padding:40px 16px;">
  <div style="max-width:480px;width:100%;background:#fff;border-radius:20px;padding:48px 32px;text-align:center;border:1px solid #e5e7eb;box-shadow:0 4px 24px rgba(0,0,0,.06);">

    <div style="width:72px;height:72px;border-radius:50%;background:#dcfce7;display:flex;align-items:center;justify-content:center;margin:0 auto 24px;font-size:2rem;">
      🎉
    </div>

    <h1 style="font-size:1.5rem;font-weight:800;color:#111827;margin:0 0 12px;">¡Bienvenido a Premium!</h1>
    <p style="color:#6b7280;font-size:15px;line-height:1.6;margin:0 0 28px;">
      Tu pago fue procesado correctamente. En unos momentos tu cuenta quedará activada con acceso a alertas ilimitadas y WhatsApp.
    </p>

    <div style="background:#f0fdf4;border:1px solid #bbf7d0;border-radius:10px;padding:16px;margin-bottom:28px;font-size:13px;color:#15803d;">
      Serás redirigido automáticamente a <strong>Mis Alertas</strong> en unos segundos…
    </div>

    <a routerLink="/mis-alertas"
       style="display:inline-block;background:#1d4ed8;color:#fff;padding:12px 32px;border-radius:10px;text-decoration:none;font-weight:600;font-size:14px;">
      Ir a Mis Alertas ahora
    </a>
  </div>
</section>
